/* __next_internal_client_entry_do_not_use__ defaultProps,TypographyContext,TypographyStyles auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { Core, Decorative } from "@faire/design-tokens";
import entries from "lodash/entries";
import isNil from "lodash/isNil";
import keys from "lodash/keys";
import pickBy from "lodash/pickBy";
import * as React from "react";
import Color from "../../slate/Color";
import { getWeight, TextTransform, Variants } from "../../slate/Font";
import { themeOrDefault } from "../../slate/Theme";
import { getFontStyles } from "../../slate/Theme/fontUtil";
import { Align } from "../Align";
import { convertPropsToStyle, getValueFromBooleanProps } from "../lib";
var getStyle = {
    variant: function(key, props, theme) {
        return key ? getFontStyles(theme, key, props.weight, props.serif) : {};
    },
    color: function(key, props) {
        var colorMap = {
            default: Core.text.default,
            primary: Core.text.default,
            secondary: Decorative.shade.orange,
            error: Core.text.critical
        };
        var _colorMap_key, _ref, _ref1;
        var color = (_ref1 = (_ref = (_colorMap_key = colorMap[key]) !== null && _colorMap_key !== void 0 ? _colorMap_key : colorMap[props[key]]) !== null && _ref !== void 0 ? _ref : Color[props[key]]) !== null && _ref1 !== void 0 ? _ref1 : props[key];
        return {
            color: color !== null && color !== void 0 ? color : Core.text.default
        };
    },
    align: function(key) {
        return {
            "text-align": Align[key]
        };
    },
    // eslint-disable-next-line @faire/no-text-transform
    textTransform: function(key) {
        return {
            "text-transform": TextTransform[key]
        };
    },
    italic: function(_, props) {
        return props.italic ? {
            "font-style": "italic"
        } : {};
    },
    truncate: function(_, props) {
        return props.truncate || props.maxLines === 1 ? {
            "white-space": "nowrap",
            "text-overflow": "ellipsis",
            overflow: "hidden"
        } : {};
    },
    maxLines: function(_, props, theme) {
        // 0 is invalid, so we expect the empty object in this case
        if ((props.maxLines || -1) <= 0) {
            return {};
        }
        var font = props.sansSerif ? "sansSerif" : "serif";
        var _getValueFromBooleanProps;
        var fontVariant = (_getValueFromBooleanProps = getValueFromBooleanProps(props, keys(Variants))) !== null && _getValueFromBooleanProps !== void 0 ? _getValueFromBooleanProps : "p";
        return {
            "-webkit-line-clamp": props.maxLines,
            display: "-webkit-box",
            "-webkit-box-orient": "vertical",
            overflow: "hidden",
            "max-height": "calc(".concat(themeOrDefault(theme).fonts[font][fontVariant].lineHeight, " * ").concat(props.maxLines, ")"),
            "text-overflow": "ellipsis"
        };
    },
    weight: function(key) {
        return {
            "font-weight": getWeight(key)
        };
    },
    strikethrough: function(_, props) {
        return props.strikethrough ? {
            "text-decoration": "line-through"
        } : {};
    }
};
export var defaultProps = {
    variant: "p",
    color: Core.text.default
};
export var TypographyContext = /*#__PURE__*/ React.createContext({});
export function TypographyStyles(typography, propsFilterOrTheme, propsFilter) {
    var theme = themeOrDefault(propsFilterOrTheme);
    var props = propsFilterOrTheme && Array.isArray(propsFilterOrTheme) ? propsFilterOrTheme : propsFilter;
    var activeProps = getActiveProps(typography);
    var finalProps = _object_spread({}, defaultProps, pickBy(activeProps, function(value) {
        return !isNil(value);
    }));
    var style = pickBy(convertPropsToStyle(getStyle, finalProps, typography, theme), function(_, key) {
        return !props || (props === null || props === void 0 ? void 0 : props.includes(key));
    });
    return entries(style).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return "".concat(key, ": ").concat(value, ";");
    }).join("\n");
}
var getActiveProps = function(props) {
    return {
        variant: getValueFromBooleanProps(props, keys(Variants)),
        color: getValueFromBooleanProps(props, [
            "default",
            "primary",
            "secondary",
            "error",
            "color"
        ]),
        align: getValueFromBooleanProps(props, keys(Align)),
        // eslint-disable-next-line @faire/no-text-transform
        textTransform: getValueFromBooleanProps(props, keys(TextTransform)),
        italic: props.italic,
        truncate: props.truncate,
        weight: props.weight,
        maxLines: props.maxLines,
        strikethrough: props.strikethrough
    };
};
